module.exports = __webpack_public_path__ + "img/art10.af160ef3.png";